module.exports = __webpack_public_path__ + "img/search.21e062d9.svg";